<template>
  <div class="login">
    <section class="section container">
      <div class="columns is-centered">
        <div class="column is-half">
          <h1 class="title has-text-centered is-2">ยินดีต้อนรับ</h1>
          <h1 class="subtitle">เพื่อไม่ให้เป็นการเสียเวลา กรุณาทำการล็อคอินเพื่อกรอกใบสมัคร <strong>ค่าย Hypercube 28</strong> ตามโซเชียลที่มีให้ด้านล่างได้เลย</h1>
          <div class="field is-grouped-multiline">
            <div>
              <a class="button is-primary is-centered" style="background-color: #c71610;" @click="loginWithGoogle">
                <span class="icon">
                  <i class="fab fa-google"></i>
                </span>
                <span><strong>Login with Google</strong></span>
              </a>
            </div>
            <div>
              <a class="button is-primary has-text-centered" style="background-color: #3b5998"
                 @click="loginWithFacebook">
                <span class="icon">
                  <i class="fab fa-facebook"></i>
                </span>
                <span><strong>Login with Facebook</strong></span>
              </a>
            </div>
            <div v-if="false">
              <a class="button is-primary has-text-centered" style="background-color: #00c300" disabled>
                <span class="icon">
                  <i class="fab fa-line"></i>
                </span>
                <span><strong>Login with LINE</strong></span>
              </a>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>

    export default {
        name: "Login",
        computed: {
            user () {
                return this.$store.getters.user;
            },
            error () {
                return this.$store.getters.error;
            },
            loading () {
                return this.$store.getters.loading;
            }
        },
        watch: {
            user (auth) {
                if (auth !== null && auth !== undefined) {
                    this.$router.replace('register')
                }
            }
        },
        data: () => {
            return {
                email: ``,
                password: ``
            }
        },
        methods: {
            async login() {
                alert('Log-in pressed');
                try {
                    await this.$store.dispatch('signUserIn', {email: this.email, password: this.password});
                    // this.$router.push('register')
                } catch (e) {
                    alert(`Oops, ${e.message}`)
                }
            },
            async loginWithFacebook() {
                // alert('Log-in with Facebook');
                try {
                    await this.$store.dispatch('signUserInWithFacebook');
                    // this.$router.push('register');
                } catch (e) {
                    alert(`Oops something wrong with Facebook Log-in, ${e.message}`)
                }
            },
            async loginWithGoogle() {
                // alert('Log-in with Google');
                try {
                    await this.$store.dispatch('signUserInWithGoogle');
                    // this.$router.push('register');
                } catch (e) {
                    alert(`Oops something wrong with Google Log-in, ${e.message}`)
                }
            },
            async logout() {
                // alert('Logging user out');
                try {
                    await this.$store.dispatch('logout');
                    this.$router.push('login');
                } catch (e) {
                    alert(`Oops, ${e.message}`);
                }
            }
        }
    }
</script>

<style scoped>
  .button {
    width: 100%;
    margin-bottom: 3%;
    margin-left: auto;
    margin-right: auto;
  }

  .login {
    font-family: 'Prompt', sans-serif;
  }

  .title, .subtitle {
    margin-bottom: 7%;
  }
</style>
